import { Platform } from 'react-native';

import { EIOkeys, EIODetailsKeys, DIRECTIONS } from './Enums';

const isAndroidDevice = Platform.OS === 'android';

export const getHeaderxStatusText = status => {
  switch (status) {
    case 0:
      return EIOkeys.everything_is_ok_text;
    case 1:
      return EIOkeys.everything_is_ok_error_text;
    case 2:
      return EIOkeys.everything_is_ok_in_progress_text;
    default:
      return '';
  }
};

export const getDetailsStatusText = status => {
  switch (status) {
    case 0:
      return EIODetailsKeys.everything_is_ok_details_screen_success_text;
    case 1:
      return EIODetailsKeys.everything_is_ok_details_screen_error_text;
    case 2:
      return EIODetailsKeys.everything_is_ok_details_screen_in_progress_text;
    default:
      return '';
  }
};

export const getItemStatus = item => {
  const subItems = item.subItems || [];
  let subStatus = item.status;
  let isActive = false;
  if (subStatus === 1) {
    isActive = true;
  }
  subItems.forEach(sub => {
    if (sub.status > subStatus) {
      subStatus = sub.status;
    }
    if (sub.status === 1) {
      isActive = true;
    }
  });
  return { status: subStatus, isActive };
};

export const getStatus = data => {
  let status = 0;
  (data || []).forEach(item => {
    const itemStatus = getItemStatus(item).status;
    if (itemStatus > status) {
      status = itemStatus;
    }
  });
  return status;
};

export const getDirection = ({ dx, dy }) => {
  const delta = 40;
  const downDelta = isAndroidDevice ? 0 : delta;
  const draggedDown = dy >= downDelta;
  const deltaUp = isAndroidDevice ? delta / 2 : delta;
  const draggedUp = dy < -deltaUp;
  let dragDirection = null;
  if (draggedDown) {
    dragDirection = DIRECTIONS.down;
  }
  if (draggedUp) {
    dragDirection = DIRECTIONS.up;
  }
  return dragDirection;
};
